/* R19 — /pages/recarga (seção reload-recarga-native). JS PRÓPRIO desta página: cópia da lógica da PDP
   (assets/reload-produto.js) + mapa combinação→variante dos kits (como a /pages/oferta-300) + cupom/brinde.
   Config por página em window.__RLR (inline na seção). Estado "cupom resgatado" = classe rlr-on no #rlp. */
(function(){
  var root = document.getElementById('rlp'); if(!root) return;
  var CFG = window.__RLR || {};
  var CODE = (CFG.code || root.getAttribute('data-code') || 'PRESENTE').toUpperCase();
  var PCT = parseInt(CFG.pct || root.getAttribute('data-pct') || '20', 10);
  var LABEL_ON = (CFG.labelOn || root.getAttribute('data-label-on') || ('Finalizar com ' + PCT + '% OFF')).replace(/\s*⚡\s*$/, '');
  var LABEL_OFF = 'Comprar agora';
  var CHECK_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  var PAGE_URL = CFG.pageUrl || root.getAttribute('data-page-url') || '/pages/recarga';
  var BRINDE = CFG.brinde || { "1": "Kit de stickers", "2": "Coqueteleira", "3": "Coqueteleira + frete grátis" };
  var MAP = CFG.map || {};
  var ORDER = ['acai','mar','mango'];

  function money(cents){ return 'R$ ' + (cents/100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function unlocked(){ return root.classList.contains('rlr-on'); }
  function pixel(ev,data){ try{ if(window.fbq) fbq('track',ev,data||{}); }catch(e){} try{ if(window.ttq) ttq.track(ev,data||{}); }catch(e){} }
  function S(k,v){ try{ if(v===undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k,v); }catch(e){ return null; } }

  /* ---- Overlay: resgate do cupom (3 estados em ~1,5s → /discount/CODE?redirect=/pages/recarga?cupom=ok) ---- */
  var ov = document.getElementById('rlr-overlay'), redeem = document.getElementById('rlr-redeem');
  var REDEEM_URL = '/discount/' + encodeURIComponent(CODE) + '?redirect=' + PAGE_URL + '%3Fcupom%3Dok';
  if(redeem){
    redeem.addEventListener('click', function(){
      if(redeem.disabled) return;
      redeem.disabled = true; redeem.classList.add('is-loading');
      var steps = ['Carregando seu cupom...', 'Aplicando ' + PCT + '% OFF...', 'Pronto!'];
      redeem.innerHTML = '<span class="rlr-spin" aria-hidden="true"></span><span class="rlr-redeem-txt">' + steps[0] + '</span>';
      var txt = redeem.querySelector('.rlr-redeem-txt');
      setTimeout(function(){ txt.textContent = steps[1]; }, 500);
      setTimeout(function(){ txt.textContent = steps[2]; redeem.classList.remove('is-loading'); redeem.classList.add('is-done'); var sp = redeem.querySelector('.rlr-spin'); if(sp){ sp.outerHTML = '<span aria-hidden="true" style="display:inline-flex">' + CHECK_SVG + '</span>'; } }, 1000);
      setTimeout(function(){
        S('recarga_ok','1');
        pixel('Lead', { content_name: 'recarga_' + CODE.toLowerCase() });
        window.location.assign(REDEEM_URL);
      }, 1500);
    });
  }

  /* ---- Contagem regressiva (setting "AAAA-MM-DD HH:MM", horário de Brasília) ---- */
  (function(){
    var t = document.getElementById('rlr-timer'), val = document.getElementById('rlr-timer-val'); if(!t || !val) return;
    var raw = (t.getAttribute('data-until') || '').trim(); if(!raw) return;
    var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/); if(!m) return;
    var until = new Date(m[1] + '-' + m[2] + '-' + m[3] + 'T' + m[4] + ':' + m[5] + ':00-03:00').getTime(); if(isNaN(until)) return;
    function pad(n){ return (n < 10 ? '0' : '') + n; }
    function tick(){
      var d = until - Date.now();
      if(d <= 0){ val.textContent = 'encerrada'; t.hidden = false; clearInterval(iv); return; }
      var dd = Math.floor(d/864e5), hh = Math.floor(d%864e5/36e5), mm = Math.floor(d%36e5/6e4), ss = Math.floor(d%6e4/1e3);
      val.textContent = (dd > 0 ? dd + 'd ' : '') + pad(hh) + 'h ' + pad(mm) + 'm ' + pad(ss) + 's';
      t.hidden = false;
    }
    var iv = setInterval(tick, 1000); tick();
  })();

  /* ---- Copiar cupom (fallback caso o cookie se perca no navegador do WhatsApp) ---- */
  var copyBtn = document.getElementById('rlr-copy');
  if(copyBtn){
    copyBtn.addEventListener('click', function(){
      function done(ok){ copyBtn.textContent = ok ? 'Copiado' : 'Erro'; copyBtn.classList.toggle('is-ok', !!ok); setTimeout(function(){ copyBtn.textContent = 'Copiar'; copyBtn.classList.remove('is-ok'); }, 2200); }
      function legacy(){ try{ var ta = document.createElement('textarea'); ta.value = CODE; ta.setAttribute('readonly',''); ta.style.position='fixed'; ta.style.opacity='0'; document.body.appendChild(ta); ta.select(); var ok = document.execCommand('copy'); document.body.removeChild(ta); done(ok); }catch(e){ done(false); } }
      if(navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(CODE).then(function(){ done(true); }, function(){ legacy(); }); } else legacy();
    });
  }

  /* ---- Modal nutricional (igual PDP) ---- */
  var nutri = document.getElementById('rlp-nutri');
  if(nutri){
    root.querySelectorAll('[data-nutri-open]').forEach(function(b){ b.addEventListener('click', function(){ nutri.style.display = 'flex'; document.documentElement.style.overflow = 'hidden'; nutri.querySelector('[data-nutri-close]').focus(); }); });
    var nutriClose = function(){ nutri.style.display = 'none'; document.documentElement.style.overflow = ''; };
    nutri.querySelector('[data-nutri-close]').addEventListener('click', nutriClose);
    nutri.addEventListener('click', function(e){ if(e.target === nutri) nutriClose(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && nutri.style.display === 'flex') nutriClose(); });
  }

  /* ---- Thumbs / console de ativos / comparativo / vídeos (iguais à PDP) ---- */
  root.querySelectorAll('.rl-thumb').forEach(function(t){
    t.addEventListener('click', function(){
      var m = document.getElementById('rlp-mainimg'); if(m){ m.srcset=''; m.sizes=''; m.src = t.dataset.img; }
      root.querySelectorAll('.rl-thumb').forEach(function(o){ o.style.borderColor = 'rgba(255,255,255,.12)'; });
      t.style.borderColor = '#a855f7';
    });
  });
  root.querySelectorAll('.rl-atv').forEach(function(el){
    el.addEventListener('click', function(){
      var c = '#' + el.dataset.color;
      var svgEl = el.querySelector('.rl-atv-svg');
      var atvIcon = document.getElementById('rlp-atvicon');
      if(svgEl && atvIcon){ atvIcon.innerHTML = svgEl.innerHTML; }
      if(atvIcon){ atvIcon.style.color = c; atvIcon.style.filter = 'drop-shadow(0 0 18px ' + c + '66)'; }
      var tg = document.getElementById('rlp-atvtag'); if(tg){ tg.textContent = el.dataset.tag; tg.style.color = '#' + el.dataset.label; }
      var nm = document.getElementById('rlp-atvname'); if(nm) nm.textContent = el.dataset.name;
      var ds = document.getElementById('rlp-atvdesc'); if(ds) ds.textContent = el.dataset.desc;
      var panel = document.getElementById('rlp-atvpanel'); if(panel){ panel.style.background = c + '14'; panel.style.borderColor = c + '66'; }
      root.querySelectorAll('.rl-atv').forEach(function(b){ b.style.background = 'rgba(255,255,255,.03)'; b.style.borderColor = 'rgba(255,255,255,.12)'; b.style.color = '#a3a3b5'; b.setAttribute('aria-selected','false'); });
      el.style.background = c + '29'; el.style.borderColor = c; el.style.color = '#fff'; el.setAttribute('aria-selected','true');
    });
  });
  var segE = document.getElementById('rlp-seg-ene'), segR = document.getElementById('rlp-seg-rel');
  function segSet(rel){
    if(segE){ segE.setAttribute('aria-selected', rel ? 'false' : 'true'); segE.style.background = rel ? '#101018' : 'rgba(56,189,248,.14)'; segE.style.border = rel ? '2px solid rgba(255,255,255,.12)' : '2px solid #38bdf8'; segE.style.color = rel ? '#a3a3b5' : '#fff'; }
    if(segR){ segR.setAttribute('aria-selected', rel ? 'true' : 'false'); segR.style.background = rel ? 'rgba(163,230,53,.12)' : '#101018'; segR.style.border = rel ? '2px solid #a3e635' : '2px solid rgba(255,255,255,.12)'; segR.style.color = rel ? '#fff' : '#a3a3b5'; }
    root.querySelectorAll('.rlp-seg-mark').forEach(function(mk){
      if(rel){ mk.textContent = '✓'; mk.style.background = 'rgba(163,230,53,.18)'; mk.style.border = '1.5px solid #a3e635'; mk.style.color = '#a3e635'; }
      else { mk.textContent = '✕'; mk.style.background = 'rgba(255,255,255,.04)'; mk.style.border = '1.5px solid rgba(255,255,255,.16)'; mk.style.color = '#8a8a9c'; }
    });
    var vd = document.getElementById('rlp-seg-verdict');
    if(vd){ vd.textContent = rel ? '✓ Reload entrega tudo isso — com sabor absurdo.' : '✕ O energético comum deixa a desejar em quase tudo.'; vd.style.color = rel ? '#a3e635' : '#8a8a9c'; }
  }
  if(segE) segE.addEventListener('click', function(){ segSet(false); });
  if(segR) segR.addEventListener('click', function(){ segSet(true); });
  root.querySelectorAll('[data-rl-video]').forEach(function(card){
    var v = card.querySelector('video'), b = card.querySelector('[data-rl-play]');
    card.addEventListener('click', function(){
      if(v.paused){
        root.querySelectorAll('[data-rl-video] video').forEach(function(o){ if(o !== v){ o.pause(); o.muted = true; } });
        root.querySelectorAll('[data-rl-play]').forEach(function(o){ o.textContent = '▶'; });
        v.muted = false; v.play(); b.textContent = '❚❚';
      } else { v.pause(); b.textContent = '▶'; }
    });
  });

  /* ================= BUY BOX ================= */
  var addBtn = document.getElementById('rlp-add'); if(!addBtn) return; /* esgotado: nada abaixo */
  var addTxt = addBtn.querySelector('.rlr-cta-txt');
  function setLabel(t){ if(addTxt) addTxt.textContent = t; else addBtn.textContent = t; }
  var offers = [].slice.call(root.querySelectorAll('.rl-off'));
  var flavors = [].slice.call(root.querySelectorAll('#rlp-flavors .rl-flavor'));
  var addons = [].slice.call(root.querySelectorAll('.rl-addon'));
  var countEl = document.getElementById('rlp-count');
  var totalEl = document.getElementById('rlp-total'), totalDe = document.getElementById('rlr-total-de'), totalBrinde = document.getElementById('rlr-total-brinde');
  var parcelaEl = document.getElementById('rlp-parcela');
  var egMsg = document.getElementById('rlr-egmsg');
  var gStk = document.getElementById('rlr-brinde-stk'), gCoq = document.getElementById('rlr-brinde-coq'), fretePill = document.getElementById('rlr-frete-pill');
  var colors = [].slice.call(root.querySelectorAll('.rlr-color')), coqWarn = document.getElementById('rlr-coqwarn'), coqSub = document.getElementById('rlr-coq-sub'), coqImg = document.getElementById('rlr-coqimg');
  var state = { N: 0, total: 0, promo: 0, qty: { acai: 0, mar: 0, mango: 0 }, vid: null, vtitle: '', colorName: '' };

  function total(){ var t = 0; ORDER.forEach(function(k){ t += state.qty[k]; }); return t; }
  function flavorPossible(k){ for(var key in MAP){ if(MAP[key] && key.indexOf(state.N + ':') === 0 && MAP[key].a && key.indexOf(k + '-') > -1) return true; } return false; }
  function paintRow(r){
    var k = r.dataset.flavor, q = state.qty[k], col = r.dataset.color, plus = r.querySelector('.rl-plus');
    r.querySelector('.rl-fqty').textContent = q;
    if(!flavorPossible(k)){ r.style.opacity = '.45'; r.style.border = '2px solid rgba(255,255,255,.09)'; r.style.background = '#101018'; if(plus) plus.disabled = true; return; }
    r.style.opacity = '1';
    if(q > 0){ r.style.border = '2px solid #' + col; r.style.background = '#' + col + '1a'; } else { r.style.border = '2px solid rgba(255,255,255,.14)'; r.style.background = '#16161f'; }
    if(plus) plus.disabled = false;
  }
  /* tema dinâmico: imagem do 1º sabor com qtd>0 (como na PDP) */
  function theme(){
    var first = null;
    flavors.forEach(function(f){ if(!first && state.qty[f.dataset.flavor] > 0) first = f; });
    if(!first) return;
    var c = '#' + first.dataset.color;
    var stage = document.getElementById('rlp-stage'), tag = document.getElementById('rlp-stagetag');
    if(stage) stage.style.borderColor = c + '66';
    if(tag){ tag.style.display = 'block'; tag.style.background = c; tag.textContent = (first.dataset.title || '').toUpperCase(); }
    if(first.dataset.img){ var m = document.getElementById('rlp-mainimg'); if(m && m.src !== first.dataset.img){ m.srcset = ''; m.sizes = ''; m.src = first.dataset.img; } }
  }
  function resolve(){
    var t = total();
    if(countEl){ countEl.textContent = 'QUANTIDADE ' + t + '/' + state.N; countEl.style.color = (t === state.N) ? '#a3e635' : '#f59e0b'; }
    flavors.forEach(paintRow);
    state.vid = null; state.vtitle = ''; if(egMsg) egMsg.hidden = true;
    if(t === state.N && state.N > 0){
      var sig = ORDER.map(function(k){ var s = ''; for(var n = 0; n < state.qty[k]; n++){ s += k + '-'; } return s; }).join('');
      var entry = MAP[state.N + ':' + sig];
      if(entry && entry.a){ state.vid = String(entry.id); state.vtitle = entry.t || ''; } else if(egMsg){ egMsg.hidden = false; }
    }
    theme();
    update();
  }
  function needsColor(){ return state.N >= 2; }
  function paintBrinde(){
    if(gStk) gStk.hidden = (state.N !== 1);
    if(gCoq) gCoq.hidden = !needsColor();
    if(fretePill) fretePill.hidden = (state.N !== 3);
    if(totalBrinde) totalBrinde.textContent = '+ ' + (BRINDE[String(state.N)] || 'brinde') + ' de brinde';
  }
  function setOffer(idx){
    var target = offers.filter(function(o){ return o.dataset.idx === String(idx); })[0];
    if(!target || target.dataset.soldout === '1') return;
    state.N = idx; ORDER.forEach(function(k){ state.qty[k] = 0; });
    offers.forEach(function(o){
      var on = o.dataset.idx === String(idx);
      if(!on){
        o.style.background = '#232338'; o.style.border = '2px solid rgba(255,255,255,.30)'; o.style.boxShadow = 'none'; o.setAttribute('aria-checked','false');
        var r = o.querySelector('.rl-radio'); r.style.borderColor = 'rgba(255,255,255,.45)'; r.style.background = 'transparent'; r.textContent = '';
        o.querySelectorAll('.rl-off-price').forEach(function(p){ p.style.color = '#fff'; });
      } else {
        o.style.background = 'linear-gradient(#20203a,#20203a) padding-box, linear-gradient(90deg,#7c3aed,#2563eb) border-box'; o.style.border = '2px solid transparent'; o.style.boxShadow = '0 12px 34px rgba(124,58,237,.4)'; o.setAttribute('aria-checked','true');
        var er = o.querySelector('.rl-radio'); er.style.borderColor = 'transparent'; er.style.background = 'linear-gradient(135deg,#7c3aed,#2563eb)'; er.textContent = '✓';
        o.querySelectorAll('.rl-off-price').forEach(function(p){ p.style.color = '#a3e635'; });
        state.total = parseInt(o.dataset.total, 10) || 0;
        state.promo = parseInt(o.dataset.promo, 10) || state.total;
      }
    });
    /* pré-preenche o 1º sabor possível com a quantidade do kit (CTA nasce destravado, como na PDP) */
    var af = null;
    flavors.forEach(function(f){ if(!af && flavorPossible(f.dataset.flavor)) af = f; });
    if(af){ state.qty[af.dataset.flavor] = state.N; }
    paintBrinde();
    resolve();
  }
  function stepFlavor(row, dir){
    var k = row.dataset.flavor;
    if(dir > 0){
      if(!flavorPossible(k)) return;
      if(total() >= state.N){
        /* R8: no limite, remaneja 1 unidade de outro sabor (troca em 1 toque) */
        var donor = null; ORDER.forEach(function(o){ if(!donor && o !== k && state.qty[o] > 0) donor = o; });
        if(!donor) return;
        state.qty[donor]--;
      }
      state.qty[k]++;
    } else { if(state.qty[k] <= 0) return; state.qty[k]--; }
    resolve();
  }
  function setColor(btn){
    if(!btn || btn.disabled) return;
    colors.forEach(function(c){ c.classList.remove('is-sel'); c.setAttribute('aria-checked','false'); });
    btn.classList.add('is-sel'); btn.setAttribute('aria-checked','true');
    state.colorName = btn.dataset.name || '';
    if(coqSub) coqSub.textContent = 'Cor: ' + state.colorName + ' · vai junto, sem custo';
    if(coqImg && btn.dataset.img) coqImg.src = btn.dataset.img;
    if(coqWarn) coqWarn.hidden = true;
    update();
  }
  function addonsTotal(){ var t = 0; addons.forEach(function(a){ if(a.classList.contains('on')) t += parseInt(a.dataset.price, 10) || 0; }); return t; }
  function update(){
    var on = unlocked();
    var kit = on ? state.promo : state.total;
    var t = kit + addonsTotal();
    if(totalEl) totalEl.textContent = money(t);
    if(totalDe){ totalDe.textContent = on && state.total > state.promo ? money(state.total + addonsTotal()) : ''; }
    if(parcelaEl) parcelaEl.textContent = money(Math.round(t/12));
    if(!state.vid){ addBtn.disabled = true; setLabel((total() === state.N && state.N > 0) ? 'Combinação esgotada' : 'Escolha os sabores (' + total() + '/' + state.N + ')'); return; }
    if(needsColor() && !state.colorName){ addBtn.disabled = true; setLabel('Escolha a cor da coqueteleira'); return; }
    addBtn.disabled = false; setLabel(on ? LABEL_ON : LABEL_OFF);
  }

  /* ---- Add-ons (Turbine): data-group exclusivo; coqueteleira extra abre o seletor de cor ---- */
  function paintAddon(el, on){
    el.setAttribute('aria-checked', on ? 'true' : 'false');
    var chk = el.querySelector('.rl-check');
    if(on){ el.style.border = '2px solid #a3e635'; el.style.background = 'rgba(163,230,53,.1)'; chk.style.background = '#a3e635'; chk.style.borderColor = '#a3e635'; chk.textContent = '✓'; }
    else { el.style.border = '2px solid rgba(255,255,255,.1)'; el.style.background = '#16161f'; chk.style.background = 'transparent'; chk.style.borderColor = 'rgba(255,255,255,.3)'; chk.textContent = ''; }
  }
  function toggleAddon(el){
    var on = el.classList.toggle('on');
    if(on && el.dataset.group){ addons.forEach(function(o){ if(o !== el && o.dataset.group === el.dataset.group && o.classList.contains('on')){ o.classList.remove('on'); paintAddon(o, false); } }); }
    paintAddon(el, on);
    if(el.id === 'rlp-coq-addon'){ var pick = document.getElementById('rlp-coqpick'); if(pick) pick.style.display = on ? 'grid' : 'none'; }
    update();
  }
  addons.forEach(function(a){
    a.addEventListener('click', function(){ toggleAddon(a); });
    a.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); toggleAddon(a); } });
  });
  root.querySelectorAll('.rl-coqvar').forEach(function(cv){
    cv.addEventListener('click', function(){
      if(cv.disabled) return;
      var addon = document.getElementById('rlp-coq-addon'); if(!addon) return;
      addon.dataset.vid = cv.dataset.vid;
      if(!addon.classList.contains('on')) toggleAddon(addon);
      root.querySelectorAll('.rl-coqvar').forEach(function(v){ v.style.border = '2px solid rgba(255,255,255,.1)'; v.style.background = '#16161f'; var n = v.querySelector('.rl-coqname'); if(n) n.style.color = '#a3a3b5'; });
      cv.style.border = '2px solid #a3e635'; cv.style.background = 'rgba(163,230,53,.1)';
      var nm = cv.querySelector('.rl-coqname'); if(nm) nm.style.color = '#fff';
      var sub = document.getElementById('rlp-coq-sub'); if(sub) sub.textContent = 'Assinatura: ' + cv.dataset.name;
      var box = document.getElementById('rlp-coq-img'); var im = cv.querySelector('img');
      if(box && im) box.innerHTML = '<img src="' + im.src + '" alt="" style="width:100%;height:100%;object-fit:cover;">';
    });
  });

  /* ---- Eventos da buy box ---- */
  offers.forEach(function(o){
    o.addEventListener('click', function(){ setOffer(parseInt(o.dataset.idx, 10)); });
    o.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); setOffer(parseInt(o.dataset.idx, 10)); } });
  });
  flavors.forEach(function(f){ f.querySelectorAll('.rl-step').forEach(function(b){ b.addEventListener('click', function(){ if(b.disabled) return; stepFlavor(f, parseInt(b.dataset.dir, 10)); }); }); });
  colors.forEach(function(c){ c.addEventListener('click', function(){ setColor(c); }); });

  /* ---- Cupom via Ajax API (só se a versão da loja expõe discount_codes no /cart.js); senão ignora ---- */
  function tryAjaxDiscount(){
    if(!unlocked()) return Promise.resolve();
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if(!cart || !Object.prototype.hasOwnProperty.call(cart, 'discount_codes')) return;
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: CODE }) })
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(c){ try{ if(c && c.discount_codes){ console.info('[RL recarga] discount_codes:', JSON.stringify(c.discount_codes)); } }catch(e){} });
      })
      .catch(function(){ /* nunca bloqueia o checkout */ });
  }
  /* Destino: com cupom resgatado, re-estampa o cookie do desconto e cai no checkout; senão o RLCheckout padrão. */
  function go(){
    if(unlocked()){ window.location.assign('/discount/' + encodeURIComponent(CODE) + '?redirect=%2Fcheckout'); return; }
    if(window.RLCheckout){ window.RLCheckout.touch(); window.RLCheckout.go({ timeout: 8000, onFail: function(){ window.location.href = '/cart'; } }); }
    else window.location.href = '/cart';
  }

  /* ---- Comprar/Finalizar → clear → add.js (kit + properties do brinde + add-ons) → cupom → checkout ---- */
  addBtn.addEventListener('click', function(){
    if(!state.vid || addBtn.disabled) return;
    if(needsColor() && !state.colorName){ if(coqWarn) coqWarn.hidden = false; return; }
    var props = { 'Brinde': BRINDE[String(state.N)] || 'Brinde' };
    if(needsColor()) props['Cor da coqueteleira'] = state.colorName;
    var items = [{ id: parseInt(state.vid, 10), quantity: 1, properties: props }];
    addons.forEach(function(a){ if(a.classList.contains('on')) items.push({ id: parseInt(a.dataset.vid, 10), quantity: parseInt(a.dataset.qty, 10) || 1 }); });
    var label = addTxt ? addTxt.textContent : addBtn.textContent;
    addBtn.disabled = true; setLabel('Preparando seu pedido…');
    pixel('AddToCart', { value: ((unlocked() ? state.promo : state.total) + addonsTotal())/100, currency: 'BRL', content_name: 'recarga_' + state.N + '_potes' });
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function(){ return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }); })
      .then(function(r){ if(!r.ok) throw new Error('cart'); return r.json(); })
      .then(tryAjaxDiscount)
      .then(function(){ setLabel('Indo pro checkout…'); go(); })
      .catch(function(){ setLabel('Erro — tente de novo'); addBtn.disabled = false; setTimeout(function(){ if((addTxt ? addTxt.textContent : addBtn.textContent) === 'Erro — tente de novo') setLabel(label); }, 2500); });
  });

  /* init: kit de 2 (mais vendido); se esgotado, o primeiro disponível */
  var first = offers.filter(function(o){ return o.dataset.soldout !== '1'; })[0];
  var def = offers.filter(function(o){ return o.dataset.idx === '2' && o.dataset.soldout !== '1'; })[0] || first;
  if(def) setOffer(parseInt(def.dataset.idx, 10));
})();
